import { useTranslation } from 'react-i18next'

import { DotsThreeCircleVertical, PencilSimple, Trash } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { ButtonMenu, Chip, IconButton, Switch, Text } from '@reveni-io/reveni-ui'

import { getReasonLabel } from '@/common/helpers/helpers'

import { returnReasonsFilteringTypes } from '../ReturnReasonDetailConfiguration/constants'
import CategoriesChip from './CategoriesChip/CategoriesChip'
import ProductTypeChip from './ProductTypeChip/ProductTypeChip'
import SubReasonsChip from './SubReasonsChip/SubReasonsChip'
import { transactionTypes } from './constants'
import * as Styles from './styles'

const ReturnReason = ({
  reason,
  index,
  onEdit,
  onDelete,
  onChangeEnabled,
  isEditable = true,
  returnReasonsFiltering,
}) => {
  const theme = useTheme()
  const { t, i18n } = useTranslation()
  const language = i18n.language

  const getLabel = () => getReasonLabel(reason, language)

  return (
    <Styles.MainContainer index={index} onClick={() => onEdit(reason)}>
      <Styles.Container>
        <Styles.SwitchAndLabelContainer>
          <Switch
            checked={reason?.is_enabled}
            onChange={e => onChangeEnabled(reason, e.target.checked)}
            onClick={e => e.stopPropagation()}
            disabled={!isEditable}
          />
          <Text type="bodyMBold" color={reason?.is_enabled ? theme.colors.text.default : theme.colors.text.subtle}>
            “{getLabel()}”
          </Text>
        </Styles.SwitchAndLabelContainer>
        {isEditable && (
          <Styles.ActionsContainer>
            <ButtonMenu
              stopPropagation
              menuItems={[
                {
                  label: (
                    <Styles.MenuItem>
                      <PencilSimple /> {t('Editar')}
                    </Styles.MenuItem>
                  ),
                  onClick: () => onEdit(reason),
                },
                {
                  label: (
                    <Styles.MenuItem>
                      <Trash />
                      {t('Eliminar')}
                    </Styles.MenuItem>
                  ),
                  onClick: () => onDelete(reason),
                },
              ]}
              renderButton={onClick => (
                <IconButton
                  variant="text"
                  onClick={onClick}
                  icon={<DotsThreeCircleVertical size={24} weight="light" />}
                />
              )}
            />
          </Styles.ActionsContainer>
        )}
      </Styles.Container>
      <Styles.TagsContainer>
        {reason?.transaction_types?.map((transactionType, index) => (
          <Chip
            key={index}
            disabled={!reason?.is_enabled}
            label={t(transactionTypes[transactionType]?.label)}
            Icon={transactionTypes[transactionType]?.icon}
          />
        ))}
        {returnReasonsFiltering === returnReasonsFilteringTypes.productTypes && (
          <ProductTypeChip isEnabled={reason?.is_enabled} productTypes={reason?.product_types} />
        )}
        {returnReasonsFiltering === returnReasonsFilteringTypes.productCategories && (
          <CategoriesChip isEnabled={reason?.is_enabled} categories={reason?.product_external_categories} />
        )}
        <SubReasonsChip subReasons={reason?.subreasons} />
      </Styles.TagsContainer>
    </Styles.MainContainer>
  )
}

export default ReturnReason
